import { Component } from '@theme/component';

class StickyATC extends Component {
  /** @type {IntersectionObserver | null} */
  #observer = null;
  /** @type {HTMLElement | null} */
  #formContainer = null;
  /** @type {HTMLElement | null} */
  #button = null;
  /** @type {AbortController} */
  #abort = new AbortController();

  connectedCallback() {
    super.connectedCallback?.();

    this.#button = this.querySelector('.sticky-atc__button');

    const section = this.closest('.shopify-section');
    this.#formContainer = section?.querySelector('.buy-buttons-block, [data-type="add-to-cart-form"], product-form-component') ?? null;

    // Observe the main add-to-cart area visibility
    if (this.#formContainer && 'IntersectionObserver' in window) {
      this.#observer = new IntersectionObserver(this.#onIntersect, {
        root: null,
        rootMargin: '0px',
        threshold: [0],
      });
      this.#observer.observe(this.#formContainer);
    }

    // Click handler
    this.#button?.addEventListener('click', this.#onClick, { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.#observer?.disconnect();
    this.#abort.abort();
  }

  /** @param {IntersectionObserverEntry[]} entries */
  #onIntersect = (entries) => {
    const entry = entries[0];
    if (!entry) return;

    const isVisible = entry.isIntersecting;
    this.toggleAttribute('hidden', isVisible);
  };

  #onClick = () => {
    const isMultiVariant = this.dataset.multiVariant === 'true';

    // If multiple variants, scroll to the product form
    if (isMultiVariant) {
      this.#formContainer?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Single variant: submit the product form
    const productFormComponent = this.closest('.shopify-section')?.querySelector('product-form-component');
    const form = productFormComponent?.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const submitButton = productFormComponent.querySelector('[ref="addToCartButton"]');
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.click();
    } else {
      form.requestSubmit?.();
    }
  };
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyATC);
}

// Auto-initialize all sticky-atc nodes in the DOM for non-CustomElement environments
document.querySelectorAll('[data-sticky-atc]').forEach((el) => {
  if (!(el instanceof HTMLElement)) return;
  if (el instanceof StickyATC) return;
  // Upgrade by setting the correct tag if using data attribute wrapper
});


